var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center flex-column align-items-center"},[_c('h5',[_vm._v(_vm._s(_vm.$t('unsubscribe.title')))]),(_vm.submitting)?_c('div',[_c('LoadingSpinner')],1):_c('div',[_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.unsub}},[_vm._v(_vm._s(_vm.$t('unsubscribe.unsubscribe')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }